import { render, staticRenderFns } from "./ChemPopover.vue?vue&type=template&id=1f7c7048"
import script from "./ChemPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./ChemPopover.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports